import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
const Customer = lazy(() => import("../screens/Customer"));
const Dashboard = lazy(() => import("../screens/Dashboard"));
const Master = lazy(() => import("../screens/master/Master"));
const MyWorkSpace = lazy(() => import("../screens/MyWorkSpace"));
const Tags = lazy(() => import("../screens/Tags"));
const Setting = lazy(() => import("../screens/Setting"));
import MainLayout from "../layout/MainLayout";
import axiosInstance from "../global";
const All = lazy(() => import("../screens/All"));
const TeamTickets = lazy(() => import("../screens/TeamTickets"));
const TicketTransfer = lazy(() => import("../screens/Team Components/TicketTransfer"));
const ProductCategory = lazy(() => import("../screens/Master Component/ProductCategory"));
const ProductSubCategory = lazy(() => import("../screens/Master Component/ProductSubCategory"));
const Department = lazy(() => import("../screens/Master Component/Department"));
const Designation = lazy(() => import("../screens/Master Component/Designation"));
const Ticket = lazy(() => import("../screens/Master Component/Ticket"));
const SolutionConnect = lazy(() => import("../screens/Master Component/SolutionConnect"));
const Predefined = lazy(() => import("../screens/Master Component/Predefined"));
const TicketSource = lazy(() => import("../screens/Master Component/TicketSource"));
const TicketCategory = lazy(() => import("../screens/Master Component/TicketCategory"));
const AddEditStaticIp = lazy(() => import("../screens/Master Component/AddEditStaticIp"));
const UserPolicyScreen = lazy(() => import("../screens/Master Component/UserPolicyScreen"));
const CustomerDepartment = lazy(() => import("../screens/Master Component/CustomerDepartment"));
const CustomerDesignation = lazy(() => import("../screens/Master Component/CustomerDesignation"));
const MenuRole = lazy(() => import("../screens/Master Component/MenuRole"));
const DayHoursPolicy = lazy(() => import("../screens/Master Component/DayHoursPolicy"));
const Addmorecompanys = lazy(() => import("../screens/Customer screens/Addmorecompanys"));
const Newticket = lazy(() => import("../screens/ticketComponent/NewTicket"));
const EditTicket = lazy(() => import("../screens/ticketComponent/EditTicket"));
const Product = lazy(() => import("../screens/Master Component/Product"));
const EditProductPopup = lazy(() => import("../screens/Master Component/PopupScreens/EditPopupscreeen/EditProductPopup"));
const Users = lazy(() => import("../screens/Master Component/Users"));
const Brand = lazy(() => import("../screens/Master Component/Brand"));
const Unit = lazy(() => import("../screens/Master Component/Unit"));
const EditBranch = lazy(() => import("../screens/Customer screens/EditBranch"));
const Branch = lazy(() => import("../screens/Master Component/Branch"));
const Created = lazy(() => import("../screens/Created"));
const EditBranchPopup = lazy(() => import("../screens/Master Component/PopupScreens/EditPopupscreeen/EditBranchPopup"));
const Branchpopup = lazy(() => import("../screens/Master Component/PopupScreens/Branchpopup"));
const EditCompanyPopup = lazy(() => import("../screens/Customer screens/EditCompanyPopup"));
const CreatedViewTicket = lazy(() => import("../screens/CreatedComponents/CreatedViewTicket"));
const CloneTicket = lazy(() => import("../screens/ticketComponent/CloneTicket"));
const CustomerCategory = lazy(() => import("../screens/Master Component/CustomerCategory"));
const DepartmentAssign = lazy(() => import("../screens/Master Component/PopupScreens/DepartmentAssign"));
const CustomerCode = lazy(() => import("../screens/Master Component/CustomerCode"));
const TeamTicketView = lazy(() => import("../screens/Team Components/TeamTicketView"));
const AllView = lazy(() => import("../screens/Allcomponents/AllView"));
const AddNotes = lazy(() => import("../screens/Notes/AddNotes"));
const EditNotes = lazy(() => import("../screens/Notes/EditNotes "));
const Notes = lazy(() => import("../screens/Notes"));
const PredefinedPopup = lazy(() => import("../screens/Master Component/PopupScreens/PredefinedPopup"));
const EditPredefinedPopup = lazy(() => import("../screens/Master Component/PopupScreens/EditPopupscreeen/EditPredefinedPopup"));
const Profile = lazy(() => import("../screens/Profile"));
const CaseHistory = lazy(() => import("../screens/View Components/CaseHistory"));
const TicketView = lazy(() => import("../screens/myworkspaceComponent/TicketView"));
const CompanyTicket = lazy(() => import("../screens/View Components/CompanyTIcket"));
const TaggedTickets = lazy(() => import("../screens/TaggedTickets"));
const DailyReport = lazy(() => import("../screens/ReportComponents/DailyReport"));
const ClientReport = lazy(() => import("../screens/ReportComponents/ClientReports"));
const ProductReport = lazy(() => import("../screens/Product Reports"));
const TaggedTicketView = lazy(() => import("../screens/View Components/TagTIcketView"));
const Whatsapp = lazy(() => import("../screens/Communications/Whatsapp"));
const Sms = lazy(() => import("../screens/Communications/Sms"));
const EmailLog = lazy(() => import("../screens/Communications/EmailLog"));
const Conversation = lazy(() => import("../screens/Communications/Conversation"));
const MailTicketIndex = lazy(() => import("../screens/MailTicket/MailTicketIndex"));
const CreateMailTicket = lazy(() => import("../screens/MailTicket/CreateMailTicket"));
const DashBoardview = lazy(() => import("../screens/DashBoard Components/DashBoardview"));
const AppConfig = lazy(() => import("../screens/AppConfig"));
const OverAllDashboard = lazy(() => import("../screens/dashobard/OverAllDashboard"));
const AgentDashboard = lazy(() => import("../screens/dashobard/AgentDashboard"));
const CustomerDashboard = lazy(() => import("../screens/dashobard/CustomerDashboard"));
const SentryPage = lazy(() => import("../screens/SentryPage"));
const SearchView = lazy(() => import("../screens/Search/SearchView"));
const Feedbacks = lazy(() => import("../screens/Feedback/Feedbacks"));
const TVDashbaord = lazy(() => import("../screens/TVDashboard"));
const ReleaseNotes = lazy(() => import("../screens/ReleaseNotes"));
const FeedbackDashboard = lazy(() => import("../screens/Feedback/FeedbackDashboard"));
const ConvertToTaskPage = lazy(() => import("../screens/Allcomponents/ConvertToTaskPage"));
const TaskViewPage = lazy(() => import("../screens/Allcomponents/TaskViewPage"));
const LogsPage = lazy(() => import("../screens/LogsPage"));
const HolidayPolicy = lazy(() => import("../screens/Master Component/SecurityPolicy/HolidayPolicy"));
const Workchat = lazy(() =>
  import("@tabtree/workchat").then((m) => {
    // workchat sets global.$axios to bare axios (no baseURL) when it loads,
    // which sends every later API call to the dev server. Put ours back.
    global.$axios = axiosInstance;
    return { default: m.Workchat };
  }),
);
import "@tabtree/workchat/dist/tailwindChat.css";
const TicketApproval = lazy(() => import("../screens/Approval/TicketApproval"));
const ApprovalView = lazy(() => import("../screens/Approval/ApprovalView"));
const AgentReport = lazy(() => import("../screens/ReportComponents/Agent Report/AgentReport"));
const ResolutionTimeDashboard = lazy(() => import("../screens/ReportComponents/ResolutionReport/ResolutionTimeReport"));
const BacklogReport = lazy(() => import("../screens/ReportComponents/Backlog Report/BacklogReport"));
const ProductDeptDashboard = lazy(() => import("../screens/ReportComponents/ProductDepartmentReport/ProductDepartmentReport"));
const IssueTypeDashboard = lazy(() => import("../screens/ReportComponents/IssueTypeBreakdown/IssueTypeBreakdown"));
const TicketVolumeDashboard = lazy(() => import("../screens/ReportComponents/TicketVolumeTrends/TicketVolumeTrends"));
const PatternForecastingDashboard = lazy(() => import("../screens/ReportComponents/PatternRecognitionReport/PatternRecognitionReport"));
// import KPISummaryDashboard from "../screens/ReportComponents/KPISummaryReport/KPISummaryReport";
// import KPIHealthDashboard from "../screens/ReportComponents/KPIHealthReport/KPIHealthReport";
const ResolutionTimePrediction = lazy(() => import("../screens/ReportComponents/ResolutionTimePrediction/ResolutionTimePrediction"));
const ReportsPage = lazy(() => import("../screens/ReportComponents/ReportsPage"));
const KnowledgeBase = lazy(() => import("../screens/KnowledgeBase/KnowledgeBase"));
const KbArticleEditor = lazy(() => import("../screens/KnowledgeBase/KbArticleEditor"));
const KbArticleView = lazy(() => import("../screens/KnowledgeBase/KbArticleView"));


const AppRoutes = () => {
  let cognitoUserId = localStorage.getItem("cognitoUserId");

  return (
    <Suspense fallback={null}>
      <Routes>
        <Route element={<MainLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="/Profile" element={<Profile />} />
          <Route path="/appconfig" element={<AppConfig />} />
          <Route path="/Setting" element={<Setting />} />
          <Route path="/Dashboard" element={<Dashboard />} />
          <Route path="/DepartmentDashboard" element={<OverAllDashboard />} />
          <Route path="/AgentDashboard" element={<AgentDashboard />} />
          <Route path="/CustomerDashboard" element={<CustomerDashboard />} />
          <Route path="/FeedbackDashboard" element={<FeedbackDashboard />} />
          <Route path="/Dashboard/ticketview" element={<DashBoardview />} />
          <Route
            path="/Dashboard/ticketview/AllCompanyTickets"
            element={<CompanyTicket />}
          />
          <Route
            path="/Dashboard/ticketview/CaseHistory"
            element={<CaseHistory />}
          />
          <Route path="/sentryTickets" element={<SentryPage />} />
          <Route path="/searchView" element={<SearchView />} />
          <Route path="/TvDashboard" element={<TVDashbaord />} />
          <Route path="/ReleaseNotes" element={<ReleaseNotes />} />
          <Route path="/LogsPage" element={<LogsPage />} />
          {global?.$userData?.logindata?.crm_app_license_master
            ?.TicketApproval == "Yes" && (
            <Route path="/TicketApproval" element={<TicketApproval />} />
          )}
          {(global?.$userData?.logindata?.TicketCompaniesAccess == "1" ||
            global?.$userData?.logindata?.TicketCompaniesAccess == "2") && (
            <Route path="/Company" element={<Customer />} />
          )}
          <Route path="/Knowledge" element={<KnowledgeBase />} />
          <Route path="/Knowledge/New" element={<KbArticleEditor />} />
          <Route path="/Knowledge/Edit/:id" element={<KbArticleEditor />} />
          <Route path="/Knowledge/Article/:id" element={<KbArticleView />} />
          <Route path="/Created" element={<Created />} />
          <Route path="/MyWorkspace" element={<MyWorkSpace />} />
          {/* {(global?.$userData?.logindata?.TicketingDepartmentAdmin == "Yes" ||
            global?.$userData?.logindata?.AccessAdminTicket === "Yes") && ( */}
            <Route path="/TeamTickets" element={<TeamTickets />} />
          {/* )} */}
          <Route path="/TeamTickets/TeamView" element={<TeamTicketView />} />
          <Route
            path="/TeamTickets/TeamView/TeamCompanyTickets"
            element={<CompanyTicket />}
          />
          <Route
            path="/TeamTickets/TeamView/CaseHistory"
            element={<CaseHistory />}
          />
          {global?.$userData?.logindata?.AccessAdminTicket === "Yes" && (
            <Route path="/All" element={<All />} />
          )}
          <Route path="/All/AllView" element={<AllView />} />
          <Route path="/All/AllView/CaseHistory" element={<CaseHistory />} />
          <Route
            path="/All/AllView/AllCompanyTickets"
            element={<CompanyTicket />}
          />
          {global?.$userData?.logindata?.AccessAdminTicket == "Yes" && (
            <Route path="/Master" element={<Master />} />
          )}
          <Route path="/TaggedTickets" element={<TaggedTickets />} />
          <Route
            path="/TaggedTickets/TaggedView"
            element={<TaggedTicketView />}
          />
          {/* Reports */}
          {global?.$userData?.logindata?.AccessAdminTicket == "Yes" && (
            <>
              <Route path="/Reports" element={<ReportsPage />} />
            </>
          )}
          <Route path="/DailyReports" element={<DailyReport />} />
          <Route path="/ClientReports" element={<ClientReport />} />
          <Route path="/ProductReports" element={<ProductReport />} />
          <Route path="/agent_report" element={<AgentReport />} />
          <Route
            path="/resolution_time_analysis_report"
            element={<ResolutionTimeDashboard />}
          />
          <Route path="/backlog_analysis_report" element={<BacklogReport />} />
          <Route
            path="/product_department_report"
            element={<ProductDeptDashboard />}
          />
          <Route
            path="/issue_type_breakdown_analysis"
            element={<IssueTypeDashboard />}
          />
          <Route
            path="/ticket_volume_trends"
            element={<TicketVolumeDashboard />}
          />
          <Route
            path="/pattern_recognition_forecasting"
            element={<PatternForecastingDashboard />}
          />
          {/* <Route
            path="/kpi_summary_analysis"
            element={<KPISummaryDashboard />}
          />
          <Route path="/kpi_health_analysis" element={<KPIHealthDashboard />} /> */}
          <Route
            path="/resolution_time_prediction"
            element={<ResolutionTimePrediction />}
          />
          {/*Communications */}
          <Route path="/Communication/WhatsApp" element={<Whatsapp />} />
          <Route path="/Communication/SMSLog" element={<Sms />} />
          <Route path="/Communication/EmailLog" element={<EmailLog />} />
          <Route
            path="/Communication/Conversation"
            element={<Conversation />}
          />
          <Route path="/Notes" element={<Notes />} />
          <Route path="/Notes/AddNotes" element={<AddNotes />} />
          <Route path="/Notes/EditNotes" element={<EditNotes />} />
          <Route path="/mail_to_ticket" element={<MailTicketIndex />} />
          <Route path="/create_mail_to_ticket" element={<CreateMailTicket />} />
          <Route path="/Tags" element={<Tags />} />
          <Route path="/TicketTransfer" element={<TicketTransfer />} />
          <Route path="/TicketView" element={<TicketView />} />
          <Route path="/ApprovalView" element={<ApprovalView />} />
          <Route
            path="/TicketView/CompanyTickets"
            element={<CompanyTicket />}
          />
          <Route path="/TicketView/CaseHistory" element={<CaseHistory />} />
          <Route path="/CreatedView" element={<CreatedViewTicket />} />
          <Route path="/EditTicket" element={<EditTicket />} />
          <Route path="/CloneTicket" element={<CloneTicket />} />
          <Route path="/AddTicket" element={<Newticket />} />
        </Route>
      </Routes>

      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/Master/Product" element={<Product />} />
          <Route path="/Master/ProductCategory" element={<ProductCategory />} />
          <Route
            path="/Master/ProductSubCategory"
            element={<ProductSubCategory />}
          />
          <Route
            path="/Master/Product/EditProduct"
            element={<EditProductPopup />}
          />
          <Route path="/Master/Brand" element={<Brand />} />
          <Route path="/Master/Unit" element={<Unit />} />
          <Route path="/Master/Department" element={<Department />} />
          <Route
            path="/Master/Department/AssignDepartment"
            element={<DepartmentAssign />}
          />
          <Route path="/Master/Designation" element={<Designation />} />
          <Route path="/Master/Role" element={<MenuRole />} />
          <Route path="/Master/Ticket" element={<Ticket />} />
          <Route path="/Master/SolutionConnect" element={<SolutionConnect />} />
          <Route path="/Master/PredefinedReply" element={<Predefined />} />
          <Route
            path="/Master/PredefinedReply/AddPredefinedReply"
            element={<PredefinedPopup />}
          />
          <Route
            path="/Master/PredefinedReply/EditPredefinedReply"
            element={<EditPredefinedPopup />}
          />
          <Route path="/Master/TicketSource" element={<TicketSource />} />
          <Route path="/Master/TicketCategory" element={<TicketCategory />} />
          <Route path="/Master/AddEditStaticIp" element={<AddEditStaticIp />} />
          <Route path="/Master/DayHourPolicy" element={<DayHoursPolicy />} />
          <Route path="/Master/UserPolicy" element={<UserPolicyScreen />} />
          <Route path="/Master/HolidayPolicy" element={<HolidayPolicy />} />
          {/* <Route path="/Master/CustomerUpload" element={<CustomerUpload />} /> */}
          {/* <Route path="/Master/Menu" element={<Menu />} /> */}
          {/* <Route path="/Master/MenuGroup" element={<MenuGroups />} /> */}
          {/* <Route path="/Master/SideBar" element={<SideBar />} /> */}
          <Route
            path="/Master/CustomerDepartment"
            element={<CustomerDepartment />}
          />
          <Route
            path="/Master/CustomerDesignation"
            element={<CustomerDesignation />}
          />
          <Route
            path="/Master/CustomerCategory"
            element={<CustomerCategory />}
          />
          <Route path="/Master/Users" element={<Users />} />
          <Route path="/Master/Branch" element={<Branch />} />
          <Route path="/Master/Branch/AddBranch" element={<Branchpopup />} />
          <Route
            path="/Master/Branch/EditBranch"
            element={<EditBranchPopup />}
          />
          <Route path="/Master/CustomerCode" element={<CustomerCode />} />
          <Route path="/Company/AddCompanies" element={<Addmorecompanys />} />
          <Route path="/Company/EditCompany" element={<EditCompanyPopup />} />

          {/* <Route path="/Company/AddContact" element={<Addmorcontact />} />   */}
          <Route path="/Company/EditBranch" element={<EditBranch />} />
          {/* <Route path="/MyWorkspace/AddTicket" element={<Newticket />} /> */}
          <Route path="/Master/Feedbacks" element={<Feedbacks />} />

          <Route
            path="/TicketView/ConvertToTask"
            element={<ConvertToTaskPage />}
          />
          <Route path="/TicketView/TaskViewPage" element={<TaskViewPage />} />
        </Route>
      </Routes>
      {/* {global.$userData.logindata.AppCode != 56 && (
        <Suspense fallback={null}>
        <Workchat
          color="#0071BC"
          noOfChat={1}
          senderContainerColor="#0071BC"
          senderTextColor="#fff"
          receiverContainerColor={"#fff"}
          receiverTextColor="#232323"
          sendButtonColor="#0071BC"
          chatWidth="300px"
          chatHeight="400px"
          senderDateTextColor={"#fff"}
          receiverDateTextColor="#232323"
          cognitoUserId={cognitoUserId}
          email={global?.$userData?.logindata.UserEmailId}
          groupUserNameColors={[
            "#3B82F6",
            "#8B5CF6",
            "#EF4444",
            "#10B981",
            "#F59E0B",
            "#6366F1",
            "#EC4899",
            "#14B8A6",
            "#F97316",
            "#A855F7",
          ]}
          ctaButtonColor={"#fff"}
          ctaButtonText={"#000fff"}
          workchatUrl="https://chat.nte.ai/app"
        />
        </Suspense>
      )} */}
    </Suspense>
  );
};

export default AppRoutes;
